var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#00162b",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.273 21.273H26v-5.11c0-.482-.295-.917-.743-1.096l-4.423-1.773c-.448-.179-.742-.612-.743-1.094v-1.038c1.459-.837 2.36-2.39 2.364-4.071V4.727c0-1.689-.9-3.25-2.364-4.094-1.462-.845-3.265-.845-4.727 0M15.802 16.249l-4.422-1.773c-.448-.179-.742-.612-.744-1.094v-.533c3.865-.517 4.728-2.213 4.728-2.213S13 8.273 13 5.91c0-2.61-2.116-4.727-4.727-4.727S3.545 3.298 3.545 5.909c0 2.364-2.363 4.727-2.363 4.727s.863 1.696 4.727 2.213v.533c0 .483-.295.917-.743 1.096L.743 16.251c-.448.18-.742.612-.743 1.095v3.927h16.545v-3.927c0-.484-.294-.918-.743-1.097z",
    transform: "translate(1 1)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profile.585f98f7.svg";
export { ForwardRef as ReactComponent };